export const MENU_BAR_KEY = "cc-menu-bar";
export const MENU_PANEL_KEY = "cc-menu-panel";
